import type { ToolbarActionModal } from '@atlassian/jira-floating-toolbar/src/common/types.tsx';
import type { useIntl } from '@atlassian/jira-intl';
import { asyncBulkDeleteModalEntryPoint } from '../entrypoint.tsx';
import { messages } from './messages.tsx';

export const MAX_ISSUES_DELETE_LIMIT = 50;

export const getDeleteModalAction = (
	selectedIssueIds: string[],
	formatMessage: ReturnType<typeof useIntl>['formatMessage'],
): ToolbarActionModal<typeof asyncBulkDeleteModalEntryPoint> => {
	const title = formatMessage(messages.title, { count: selectedIssueIds.length });
	return {
		type: 'modal',
		entryPoint: asyncBulkDeleteModalEntryPoint,
		name: formatMessage(messages.deteleButton),
		isDisabled: selectedIssueIds.length > MAX_ISSUES_DELETE_LIMIT,
		disabledMessage: formatMessage(messages.maxIssuesExceededWarning, {
			maxIssueLimit: MAX_ISSUES_DELETE_LIMIT,
		}),
		entryPointParams: undefined,
		entryPointProps: {
			selectedIssueIds,
			modalTitle: title,
		},
		title,
	};
};
